import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import AutocompleteVirtualizedBase from 'components/mui/Form/Autocomplete/AutocompleteVirtualizedBase';

export type Option = { label: string; value: string };

type Props = {
  name: string;
  label: string;
  options: Option[];
  required?: boolean;
  disabled?: boolean;
  disableClearable?: boolean;
};

// react-hook-form-wired virtualized autocomplete with touched-error display.
// Shared by the generic FormField and the open_finance form.
const RhfAutocomplete: React.FC<Props> = ({ name, label, options, required, disabled, disableClearable }) => {
  const { formatMessage } = useIntl();
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <AutocompleteVirtualizedBase
          fullWidth
          options={options}
          value={options.find((o) => o.value === field.value) ?? null}
          onChange={(_: unknown, option: Option | null) => field.onChange(option?.value)}
          disableClearable={disableClearable}
          disabled={disabled}
          textFieldProps={{
            label,
            required,
            error: !!fieldState.error && fieldState.isTouched,
            helperText:
              fieldState.isTouched && fieldState.error?.message
                ? formatMessage({ id: fieldState.error.message, defaultMessage: fieldState.error.message })
                : undefined,
          }}
        />
      )}
    />
  );
};

export default RhfAutocomplete;
